var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "admin-zones" },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("zones.checkZone"),
                      name: "checkZone",
                    },
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("zones.checkZone")))]),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  "value-key": "id",
                                  placeholder: _vm.$t("zones.selectCustomer"),
                                },
                                on: { change: _vm.loadSelectedZone },
                                model: {
                                  value: _vm.selectedCustomer,
                                  callback: function ($$v) {
                                    _vm.selectedCustomer = $$v
                                  },
                                  expression: "selectedCustomer",
                                },
                              },
                              _vm._l(_vm.customers, function (customer) {
                                return _c(
                                  "el-option",
                                  {
                                    key: customer.id,
                                    attrs: {
                                      label:
                                        customer.company +
                                        " - (" +
                                        customer.code +
                                        ")",
                                      value: customer,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "min-width": "200px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.company))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.code))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "zone-table" }, [
                            _vm.zones.length === 0
                              ? _c("div", [
                                  _c("p", { staticClass: "no-zone" }, [
                                    _vm._v(_vm._s(_vm.$t("zones.noZone"))),
                                  ]),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { data: _vm.zones },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            fixed: "",
                                            prop: "name",
                                            label: _vm.$t("zones.name"),
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "code",
                                            label: _vm.$t("zones.code"),
                                            width: "200",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "project",
                                            label: _vm.$t("zones.project"),
                                            width: "200",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: _vm.$t("zones.color"),
                                            width: "200",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("div", {
                                                      staticClass: "color-box",
                                                      style:
                                                        "background-color: " +
                                                        scope.row.color,
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            328563686
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            align: "right",
                                            label: _vm.$t("zones.waypoints"),
                                            width: "200",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.wayPoints
                                                            .length
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            564024447
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("zones.copyZone"),
                      name: "copyZone",
                    },
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("zones.copyZone")))]),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 11 } }, [
                          _c("p", [_vm._v(_vm._s(_vm.$t("zones.copyFrom")))]),
                        ]),
                        _c("el-col", { attrs: { span: 11, offset: 2 } }, [
                          _c("p", [_vm._v(_vm._s(_vm.$t("zones.copyTo")))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  "value-key": "id",
                                  placeholder: _vm.$t("zones.selectCustomer"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.loadSelectedProjectCode("from")
                                  },
                                },
                                model: {
                                  value: _vm.fromCopyCustomer,
                                  callback: function ($$v) {
                                    _vm.fromCopyCustomer = $$v
                                  },
                                  expression: "fromCopyCustomer",
                                },
                              },
                              _vm._l(_vm.customers, function (customer) {
                                return _c(
                                  "el-option",
                                  {
                                    key: customer.id,
                                    attrs: {
                                      label:
                                        customer.company +
                                        " - (" +
                                        customer.code +
                                        ")",
                                      value: customer,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "min-width": "200px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.company))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.code))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 11, offset: 2 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  "value-key": "id",
                                  placeholder: _vm.$t("zones.selectCustomer"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.loadSelectedProjectCode("to")
                                  },
                                },
                                model: {
                                  value: _vm.toCopyCustomer,
                                  callback: function ($$v) {
                                    _vm.toCopyCustomer = $$v
                                  },
                                  expression: "toCopyCustomer",
                                },
                              },
                              _vm._l(_vm.customers, function (customer) {
                                return _c(
                                  "el-option",
                                  {
                                    key: customer.id,
                                    attrs: {
                                      label:
                                        customer.company +
                                        " - (" +
                                        customer.code +
                                        ")",
                                      value: customer,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "min-width": "200px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.company))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [_vm._v(_vm._s(customer.code))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100 mt-8",
                                attrs: {
                                  "value-key": "RecId",
                                  placeholder: _vm.$t(
                                    "zones.selectProjectCode"
                                  ),
                                },
                                model: {
                                  value: _vm.fromProjectCode,
                                  callback: function ($$v) {
                                    _vm.fromProjectCode = $$v
                                  },
                                  expression: "fromProjectCode",
                                },
                              },
                              _vm._l(_vm.fromProjectCodes, function (project) {
                                return _c(
                                  "el-option",
                                  {
                                    key: project.RecId,
                                    attrs: {
                                      label:
                                        project.ProjectCode +
                                        " - (" +
                                        project.ProjectName +
                                        ")",
                                      value: project,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "min-width": "200px",
                                        },
                                      },
                                      [_vm._v(_vm._s(project.ProjectCode))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [_vm._v(_vm._s(project.ProjectName))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 11, offset: 2 } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100 mt-8",
                                attrs: {
                                  "value-key": "RecId",
                                  placeholder: _vm.$t(
                                    "zones.selectProjectCode"
                                  ),
                                },
                                model: {
                                  value: _vm.toProjectCode,
                                  callback: function ($$v) {
                                    _vm.toProjectCode = $$v
                                  },
                                  expression: "toProjectCode",
                                },
                              },
                              _vm._l(_vm.toProjectCodes, function (project) {
                                return _c(
                                  "el-option",
                                  {
                                    key: project.RecId,
                                    attrs: {
                                      label:
                                        project.ProjectCode +
                                        " - (" +
                                        project.ProjectName +
                                        ")",
                                      value: project,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "min-width": "200px",
                                        },
                                      },
                                      [_vm._v(_vm._s(project.ProjectCode))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          color: "#8492a6",
                                          "font-size": "13px",
                                        },
                                      },
                                      [_vm._v(_vm._s(project.ProjectName))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6, offset: 18 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "w-100 mt-8",
                                attrs: {
                                  disabled: _vm.copyDisable,
                                  type: "primary",
                                },
                                on: { click: _vm.copyZones },
                              },
                              [_vm._v(_vm._s(_vm.$t("zones.copy")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }